import React from 'react'
import ButtonAction, { ButtonActionProps } from 'components/shared/ButtonAction'

const DeleteButton: React.FC<Omit<ButtonActionProps, 'text'>> = ({ ...props }) => {
  return <ButtonAction text='Delete' bold {...props} />
}

export default DeleteButton
